import React from 'react';
import CommonAppSetup from '../../../common/common-app-setup/CommonAppSetup';
import PropTypes from 'prop-types';
import Components from '../../../common/Components';
import joinClassNames from "../../../common/JoinClassNames";

/**
 * InputContainer is a wrapper component that will receive
 * the className for form components that have a "label" and "input"
 *
 * This will allow you to target the children from the parent.
 */

const propTypes = {
	// children components
	children: PropTypes.node,

	// additional css classes to put on the component
	className: PropTypes.string,
};

const defaultProps = {
	children: undefined,
	className: undefined,
};

export default class InputContainer extends React.Component {
	render() {
		return (
			<div className={joinClassNames(
				'input-container',
				this.props.className,
				CommonAppSetup.getClassName(Components.INPUT_CONTAINER, 'inputContainer')
			)}>
				{this.props.children}
			</div>
		);
	}
}

InputContainer.defaultProps = defaultProps;
InputContainer.propTypes = propTypes;